import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.KS_ENV !== 'prod' });

/** 商品广场  加入小黄车 */
export async function addCarUsingPOST(params: { addCarParam: model.IAddCarParam }) {
    const result = await axios.post<model.IMessageResultCodeVo>(`/rest/op/vc/distribution/pool/addCar`, {
        ...params.addCarParam,
    });
    return result;
}

/** 商品广场  加入选品库 */
export async function addRuleUsingPOST(params: { addRuleParam: model.IAddRuleParam }) {
    const result = await axios.post<model.IMessageResultCodeVo>(`/rest/op/vc/distribution/pool/addRule`, {
        ...params.addRuleParam,
    });
    return result;
}

/** 商品广场  加入选品库前置校验 */
export async function checkAddRuleUsingPOST(params: { addRuleCheckParam: model.IAddRuleCheckParam }) {
    const result = await axios.post<model.IMessageAddRuleCheckVO>(`/rest/op/vc/distribution/pool/addRule/check`, {
        ...params.addRuleCheckParam,
    });
    return result;
}

/** 商品广场  加入选品库V2 */
export async function addRuleV2UsingPOST(params: { addRuleParam: model.IAddRuleParam }) {
    const result = await axios.post<model.IMessageResultCodeVo>(`/rest/op/vc/distribution/pool/addRule/v2`, {
        ...params.addRuleParam,
    });
    return result;
}

/** 商品广场  商品行业 */
export async function itemIndustryUsingPOST() {
    const result = await axios.post<model.IMessageListIndustryVO>(`/rest/op/vc/distribution/pool/itemIndustry`);
    return result;
}

/** 商品广场  查询商品广场列表 */
export async function searchPoolsUsingPOST(params: { searchPoolParam: model.ISearchPoolParam }) {
    const result = await axios.post<model.IMessagePoolListVO>(`/rest/op/vc/distribution/pool/searchPools`, {
        ...params.searchPoolParam,
    });
    return result;
}

/** 商品广场  查询商品广场列表v2 */
export async function searchPoolsV2UsingPOST(params: { searchPoolParam: model.ISearchPoolParam }) {
    const result = await axios.post<model.IMessagePoolListVO>(`/rest/op/vc/distribution/pool/searchPools/v2`, {
        ...params.searchPoolParam,
    });
    return result;
}
